module.exports = __webpack_public_path__ + "img/GENERAL-CIAZ-1.d1f69e0c.jpg";